import type { SelfView } from "@bezbolisno/contracts/telegram";
import { t } from "@bezbolisno/i18n";
import { kyivDateTimeLabel } from "@bezbolisno/kit/kyiv-date";

/** The one thing a patient opens the app for: when am I next in? */
export function NextAppointment({ appointment }: { appointment: SelfView["nextAppointment"] }) {
  return (
    <section className="tg-card">
      <div className="tg-section__title" style={{ margin: 0 }}>
        {t.telegram.nextVisit}
      </div>
      {appointment ? (
        <>
          <div style={{ fontSize: "1.25rem", fontWeight: 700, marginTop: "0.25rem" }}>
            {kyivDateTimeLabel(new Date(appointment.startsAt))}
          </div>
          <div className="tg-hint tg-num" style={{ fontSize: "0.875rem" }}>
            {appointment.durationMin} {t.appointments.minutes}
          </div>
        </>
      ) : (
        <div className="tg-hint" style={{ marginTop: "0.25rem" }}>
          {t.telegram.noUpcoming}
        </div>
      )}
    </section>
  );
}
